import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Category from './views/Category.vue'
import User from './views/User.vue'
import Course from './views/Course.vue'
import Instructor from './views/Instructor.vue'
import Video from './views/Video.vue'
import Section from './views/CourseSection.vue'
import Static from './views/Static.vue'

Vue.use(Router)

var sitename = "Admin-Eclass"
function sitetitle(route){
  return sitename + ' ' + route
}


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: sitetitle("Login")
      }
    },

    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: sitetitle("Login")
      }
    },
    {
      path: '/category',
      name: 'category',
      component: Category,
      meta: {
        title: sitetitle("Category")
      }
    },
    {
      path: '/course',
      name: 'course',
      component: Course,
      meta: {
        title: sitetitle("Course")
      }
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      meta: {
        title: sitetitle("User")
      }
    },
    // {
    //   path: '/user/:page',
    //   name: 'user-page',
    //   component: User,
    //   meta: {
    //     title: sitetitle("User")
    //   }
    // },
    {
      path: '/instructor',
      name: 'instructor',
      component: Instructor,
      meta: {
        title: sitetitle("Instructor")
      }
    },
    {
      path: '/instructor/:page',
      name: 'instructor-page',
      component: Instructor,
      meta: {
        title: sitetitle("Instructor")
      }
    },
    {
      path: '/video',
      name: 'video',
      component: Video
    },
    {
      path: '/section',
      name: 'eclass-section',
      component: Section
    },
    {
      path: '/static',
      name: 'static',
      component: Static,
      meta: {
        title: sitetitle("Static")
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if(!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    tag.setAttribute('data-vue-router-controlled', '');
    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));
  next();
});
export default router;